import React from "react";
import styled from "@emotion/styled";
import {
  Accordion,
  Anchor,
  Badge,
  Breadcrumbs,
  Card,
  Container,
  Divider,
  Grid,
  Group,
  Image,
  Paper,
  RingProgress,
  SimpleGrid,
  Stack,
  Text,
  Title,
  Box,
} from "@mantine/core";
import {
  IconBuilding,
  IconCalendar,
  IconCandle,
  IconChartCandle,
  IconHome,
  IconLocation,
  IconMap,
  IconMapPin,
  IconPhoneCall,
  IconServer,
  IconServicemark,
  IconStatusChange,
  IconUsers,
} from "@tabler/icons-react";
import { Link } from "react-router-dom";
import BenchBreadcrumbs from "./Components/BenchBreadcrumbs";
import Img from "../../assets/Image.jpg";
import { Carousel } from "@mantine/carousel";
import SliderComponent from "./Components/SliderComponent";
import { useMantineTheme } from "@mantine/core";
import BenchCardRed from "./Components/BenchCardRed";

const BranchDetailspage = () => {
  const color = "white";
  const theme = useMantineTheme();

  const Branchdata = [
    {
      branch: {
        _id: "671a2b8c9f8a12c345678901",
        name: "Demo Branch",
        status: "Draft",
        completionPercentage: 50,
        location: {
          city: "Kanchipuram",
          state: "Tamil Nadu",
          address:
            "1/17, Pillaiyar Kovil Street, Kailayanoor Village, Chennai, Kanchipuram, Tamil Nadu, India 631561",
        },
        contact: {
          primaryNumber: "+91 94837 98756",
          secondaryNumber: "+91 94837 98756",
        },
        createdDate: "2025-09-30",
        staffCount: 10,
        memberCount: 100,
        benefits: [
          {
            id: 1,
            title: "Free Wi-Fi Facility",
            description:
              "Unlimited Wi-Fi access available for all members during gym hours.",
          },
          {
            id: 2,
            title: "Guest Passes",
            description:
              "Members can bring guests for trial sessions using guest passes.",
          },
          {
            id: 3,
            title: "Certified Trainers",
            description:
              "Professional and certified trainers available for personal training.",
          },
          {
            id: 4,
            title: "Diet & Nutrition Counseling",
            description:
              "Get expert guidance on diet and nutrition plans tailored to your goals.",
          },
        ],
        services: [
          {
            id: 1,
            title: "Personal Training",
            description:
              "One-on-one sessions with certified personal trainers.",
          },
          {
            id: 2,
            title: "Group Fitness Classes",
            description: "Join group classes like Zumba, Yoga, and HIIT.",
          },
          {
            id: 3,
            title: "Strength & Cardio Equipment",
            description:
              "Access to modern gym equipment for all fitness levels.",
          },
          {
            id: 4,
            title: "Body Composition Analysis",
            description:
              "Regular tracking of BMI, fat percentage, and muscle mass.",
          },
        ],
        facilities: [
          {
            id: 1,
            title: "Changing Rooms",
          },
          {
            id: 2,
            title: "Shower Facility",
          },
          {
            id: 3,
            title: "Parking Space",
          },
        ],
        map: {
          viewLink: "https://maps.google.com/?q=Kanchipuram,Tamil+Nadu",
        },
        imageGallery: [
          {
            id: 1,
            imageUrl: Img,
            alt: "Branch exterior view",
          },
          {
            id: 2,
            imageUrl: Img,
            alt: "Branch front view",
          },
          {
            id: 3,
            imageUrl: Img,
            alt: "Branch interior view",
          },
          {
            id: 3,
            imageUrl: Img,
            alt: "Branch interior view",
          },
        ],
        lastUpdated: "2025-10-15T11:30:00.000Z",
      },
    },
  ];
  const branchdata = Branchdata[0];
  const breadcrumbLinks = [
    { label: "Branch", path: "/branch" },
    { label: "Branch Detail" }, // last item has no path
  ];

  return (
    <Container size={"lg"}>
               <Box
                  sx={(theme) => ({
                    position: "sticky",
                    top: 110, // Avoid overlapping the fixed navbar
                    zIndex: 100,
                    backgroundColor: "#FAFAFA",
                    paddingTop: theme.spacing.sm,
                    //paddingBottom: theme.spacing.xs,
                    marginTop: `-${theme.spacing.sm}`,
                  })}
                >
      <BenchBreadcrumbs links={breadcrumbLinks} />
      <Divider my="sm" />
</Box>
      <Grid>
        <Grid.Col span={8}>
          <BenchCardRed mt="lg" padding="lg">
            <Grid align="center" gutter="md">
              {/* Left column */}
              <Grid.Col span={8}>
                <Group align="center" mb="sm">
                  <Title order={3} m={0}>
                    {branchdata.branch.name}
                  </Title>
                  <Badge
                    color={
                      branchdata.branch.status === "Active" ? "green" : "red"
                    }
                  >
                    {branchdata.branch.status}
                  </Badge>
                </Group>

                <Group spacing="md" mb="xs" align="center">
                  <IconMap size={18} color="red" />
                  <Text size="sm" color="dimmed">
                    {branchdata.branch.location.city},{" "}
                    {branchdata.branch.location.state}
                  </Text>

                  <IconPhoneCall size={18} color="red" />
                  <Text size="sm" color="dimmed">
                    {branchdata.branch.contact.primaryNumber}
                  </Text>
                </Group>
              </Grid.Col>

              {/* Right column */}
              <Grid.Col span={4}>
                <RingProgress
                  size={100}
                  thickness={8}
                  sections={[
                    { value: 50, color: "brand.4" },
                    { value: 50, color: "#252222ff" },
                  ]}
                  label={
                    <Text size="lg" ta="center" color={theme.colors.brand[4]}>
                      50 %
                    </Text>
                  }
                />
              </Grid.Col>
            </Grid>
          </BenchCardRed>
          <></>
          <BenchCardRed mt="lg">
            <Title order={5} mb="md">
              Branch Info
            </Title>

            <SimpleGrid cols={2} spacing="lg" mb="" p="md">
              {/* Primary Number */}
              <Group spacing="sm" align="center">
                <IconPhoneCall size={18} color="red" />
                <Stack spacing={2}>
                  <Text size="sm" fw={500} color="dimmed">
                    Primary Number
                  </Text>
                  <Text size="sm" fw={500}>
                    {branchdata.branch.contact.primaryNumber}
                  </Text>
                </Stack>
              </Group>

              {/* Secondary Number */}
              <Group spacing="sm" align="center">
                <IconPhoneCall size={18} color="red" />
                <Stack spacing={2}>
                  <Text size="sm" fw={500} color="dimmed">
                    Secondary Number
                  </Text>
                  <Text size="sm" fw={500}>
                    {branchdata.branch.contact.secondaryNumber}
                  </Text>
                </Stack>
              </Group>
            </SimpleGrid>

            {/* Address */}
            <Group spacing="sm" align="center" mb="" p="md">
              <IconLocation size={18} color="red" />
              <Stack spacing={2}>
                <Text size="sm" fw={500} color="dimmed">
                  Address
                </Text>
                <Text
                  size="sm"
                  fw={500}
                  style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                >
                  {branchdata.branch.location.address}
                </Text>
              </Stack>
            </Group>

            <SimpleGrid cols={2} spacing="lg" mb="" p="md">
              {/* Status */}
              <Group spacing="sm" align="center">
                <IconChartCandle size={18} color="red" />
                <Stack spacing={2}>
                  <Text size="sm" fw={500} color="dimmed">
                    Status
                  </Text>
                  <Text size="sm" fw={500}>
                    {branchdata.branch.status}
                  </Text>
                </Stack>
              </Group>

              {/* Created Date */}
              <Group spacing="sm" align="center">
                <IconCalendar size={18} color="red" />
                <Stack spacing={2}>
                  <Text size="sm" fw={500} color="dimmed">
                    Created Date
                  </Text>
                  <Text size="sm" fw={500}>
                    {branchdata.branch.createdDate}
                  </Text>
                </Stack>
              </Group>
            </SimpleGrid>
            <SimpleGrid cols={2} spacing="lg" mb="" p="md">
              {/* No of Staff */}
              <Group spacing="sm" align="center">
                <IconUsers size={18} color="red" />
                <Stack spacing={2}>
                  <Text size="sm" fw={500} color="dimmed">
                    No of Staff
                  </Text>
                  <Text size="sm" fw={500}>
                    {branchdata.branch.staffCount}
                  </Text>
                </Stack>
              </Group>

              {/* No of Members */}
              <Group spacing="sm" align="center">
                <IconUsers size={18} color="red" />
                <Stack spacing={2}>
                  <Text size="sm" fw={500} color="dimmed">
                    No of Members
                  </Text>
                  <Text size="sm" fw={500}>
                    {branchdata.branch.memberCount}
                  </Text>
                </Stack>
              </Group>
            </SimpleGrid>
          </BenchCardRed>

          <BenchCardRed my="lg">
            <Title order={5} mb="md">
              Image Gallery
            </Title>

            <SliderComponent visible={3} gap={16}>
              {branchdata.branch.imageGallery.map((item) => (
                <Group key={item.imageUrl} position="center" align="center">
                  <Image
                    src={item.imageUrl}
                    width={150}
                    height={100}
                    radius="sm"
                    fit="cover"
                  />
                </Group>
              ))}
            </SliderComponent>
          </BenchCardRed>
        </Grid.Col>
        <Grid.Col span={4}>
          <BenchCardRed mt="lg">
            <Accordion>
              <Accordion.Item value="services">
                <Accordion.Control>
                  <Text fw={700}>Services</Text>
                </Accordion.Control>

                <Accordion.Panel>
                  {branchdata.branch.services.map((item) => (
                    <Group key={item.id} spacing="sm" align="center" mb="xs">
                      <IconServer color="red" size={18} />
                      <Text>{item.title}</Text>
                    </Group>
                  ))}
                </Accordion.Panel>
              </Accordion.Item>
              <Accordion.Item value="Facilities">
                <Accordion.Control>
                  {" "}
                  <Text fw="700"> Facilities</Text>
                </Accordion.Control>
                <Accordion.Panel>
                  {branchdata.branch.facilities.map((item) => (
                    <Group key={item.id} spacing="sm" align="center" mb="xs">
                      <IconServer color="red" size={18} />
                      <Text>{item.title}</Text>
                    </Group>
                  ))}
                </Accordion.Panel>
              </Accordion.Item>
              <Accordion.Item value="Benefits">
                <Accordion.Control>
                  <Text fw="700">Benefits</Text>{" "}
                </Accordion.Control>
                <Accordion.Panel>
                  {branchdata.branch.benefits.map((item) => (
                    <Group key={item.id} spacing="sm" align="center" mb="xs">
                      <IconServer color="red" size={18} />
                      <Text>{item.title}</Text>
                    </Group>
                  ))}
                </Accordion.Panel>
              </Accordion.Item>
            </Accordion>

            <Group position="center">
              <IconLocation color="red" size={18} /> <Text>View on map</Text>
            </Group>
          </BenchCardRed>
        </Grid.Col>
      </Grid>
    </Container>
  );
};

export default BranchDetailspage;
